import React, { useMemo } from "react";
import { useDarkMode } from "../context/DarkModeContext";
import { useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import AppLogo from "./navigation/AppLogo";
import ThemeToggle from "./navigation/ThemeToggle";
import UserMenu from "./navigation/UserMenu";
import { getUserMenuItems } from "./navigation/navigationConfig";

const Header = () => {
  const { user, logout } = useAuth();
  const { darkMode, toggleDarkMode } = useDarkMode();
  const location = useLocation();
  const userMenuItems = useMemo(() => getUserMenuItems(user?.role), [user?.role]);

  return (
    <nav className="fixed top-0 z-50 w-full border-b border-white/40 bg-orange-50/80 font-montserrat shadow-sm backdrop-blur-sm dark:border-gray-800 dark:bg-gray-950/75">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between gap-3">
          <AppLogo className="backdrop-blur-lg" />

          <div className="flex items-center gap-3">
            <ThemeToggle checked={darkMode} onToggle={toggleDarkMode} />
            <UserMenu
              currentPath={location.pathname}
              items={userMenuItems}
              onLogout={logout}
              user={user}
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
